<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row  class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
              <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Mitarbeiter</span>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto; margin-left: 24px"
                :disabled="this.currentItemIndex === 0"
                @click="moveSelection('left', true)"
            >
              <v-icon>mdi-page-first</v-icon>
            </v-btn>
            <v-btn
                v-if="isDetail"
                icon
                color="blue"
                style="margin-top: auto; margin-bottom: auto;"
                :disabled="this.currentItemIndex === 0"
                @click="moveSelection('left', false)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
                  v-if="isDetail"
                  icon
                  color="blue"
                  style="margin-top: auto; margin-bottom: auto;"
                  :disabled="this.currentItemIndex === this.mitas.length - 1"
                  @click="moveSelection('right', false)"

              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                  v-if="isDetail"
                  icon
                  color="blue"
                  style="margin-top: auto; margin-bottom: auto;"
                  :disabled="this.currentItemIndex === this.mitas.length - 1"
                  @click="moveSelection('right', true)"
              >
                <v-icon>mdi-page-last</v-icon>
              </v-btn>
            <v-btn
                v-if="isAdmin"
                block
                color="success"
                class="t-btn ml-2"
                @click="possibleAppsSelected = [...possibleApps];showAppSettingsDialog = true"
            >
              <v-icon left>
                mdi-android
              </v-icon>
              Einstellungen
            </v-btn>
            <v-btn
                v-if="isAdmin && !mitas.length"
                block
                color="warning"
                class="t-btn-long ml-2"
                @click="toggleSetupMode"
            >
              <v-icon left>
                mdi-pencil
              </v-icon>
              {{modeSetup ? 'Normalmodus' :'Einrichtungsmodus'}}
            </v-btn>
            <v-btn
                v-if="modeSetup"
                block
                color="success"
                class="t-btn-long ml-2"
                @click="$refs.parseFileDialog.show()"
            >
              <v-icon left>
                mdi-microsoft-excel
              </v-icon>
              Importieren
            </v-btn>
            <div class="t-btn-left"></div>
              <v-btn
                  block
                  color="success"
                  class="white--text t-btn"
                  :disabled="this.isEdit"
                  @click="toggleDetails"
                  v-if="singleEdit"
              >
                <v-icon left>
                  {{isDetail ? 'mdi-view-list' : 'mdi-eye-outline'}}
                </v-icon>
                {{isDetail ? 'Liste' : 'Details'}}
              </v-btn>
            <v-btn
                v-if="(!isEdit || !singleEdit) && modeSetup"
                block
                color="error"
                class="t-btn"
                :disabled="!hasSelects"
                @click="onDelete"
            >
              <v-icon left>
                mdi-delete
              </v-icon>
              Löschen
            </v-btn>
            <v-btn
                v-if="!isEdit || !singleEdit"
                class="white--text t-btn"
                color="primary"
                block
                @click="addRow"
            >
              <v-icon left>
                mdi-plus-circle-outline
              </v-icon>
              Anlegen
            </v-btn>
            <v-btn
                v-if="isEdit && !modeSetup"
                block
                color="warning"
                class="t-btn"
                @click="resetEdit"
            >
              <v-icon left>
                mdi-close-circle-outline
              </v-icon>
              Abbrechen
            </v-btn>
            <v-btn
                v-if="isEdit || !singleEdit"
                block
                color="success"
                class="white--text t-btn"
                :disabled="!isEdit || mitas.length === 0"
                @click="onSave"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Speichern
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="p-0">
          <spread-sheet v-if="!isDetail" ref="spreadsheet" id="spreadsheet"
                        :key="modeSetup ? 'setup' : 'normal'"
                        :collumns="cols"
                        :data="mitas"
                        :temp-col-width="50"
                        :is-single-edit="singleEdit"
                        @change="dataChanged"
                        @selection-change="selectionChange"
                        @dbl-click="dblClick"
                        style="margin-top: -1px"/>
          <mita-detail v-else ref="detail" id="detail"
                       :item="currentItem"
                       :kosts="kosts"
                       :kost-map="kostMap"
                       :azras="azras"
                       :employment-types="employmentTypes"
                       :qualifications="qualifications"
                       :app-selects="appSelects"
                       :kloon-key="kloonKey"
                       @change="dataChanged"/>
        </v-col>
      </v-row>
    </div>

    <v-dialog
        v-model="showAppSettingsDialog"
        scrollable
        max-width="300px"
    >
      <v-card>
        <v-card-title>App Einstellungen</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 300px;">
          <v-text-field
              v-model="kloonKey"
              label="Kloon Lizenzcode"
              hint="Der Kloon Lizenzcode"
          ></v-text-field>
          <v-text-field
              v-model="kloonApiKey"
              label="Kloon API-Key"
              hint="Der Kloon API-Key Lizenzcode"
          ></v-text-field>
          <v-checkbox
              v-for="app in appMap"
              :key="app.value"
              v-model="possibleAppsSelected"
              :label="app.name"
              :value="app.value"
              hide-details
          ></v-checkbox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="showAppSettingsDialog = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="showAppSettingsDialog = false; saveAppSettings()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        v-model="showErrorMessage"
        :timeout="5000"
        right
        color="red accent-2"
    >
      <b>{{ errorMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showErrorMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <parse-file-dialog ref="parseFileDialog"
                       :cols="cols"
                       :pre-defined-data="$options.importOrder"
                       :empty-item="$options.emptyMita"
                       :transform-item="$options.transformMita"
                       @import="onImport"
    />
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {DateTime as LuxonDateTime} from "luxon";
import SpreadSheet from "@/views/basis_data/common/SpreadSheet.vue";
import MitaDetail from "@/views/basis_data/mita_detail.vue";
import ParseFileDialog from "@/views/basis_data/dialogs/ParseFileDialog.vue";
import {v4} from "uuid";
import {decryptData, encryptAES, encryptData} from "@/shared/crypto";



export default {
  name: "mita_list",
  components: {
    SpreadSheet,
    MitaDetail,
    ParseFileDialog
  },
  importOrder: ['name', 'pers_number', 'ginkom01', 'azra', 'kost', 'migr', 'price_int', 'price_ext'],
  emptyMita: {
    id: '',
    bis_id: 'Neuanlage',
    kloon_id: 0,
    name: '',
    pers_number: '',
    kost: '',
    migr: '',
    azra: '',
    start_date: '',
    end_date: '',
    blocked: false,
    price_int: '',
    price_ext: '',
    ginkom01: false,
    way_time: '0',
    drivers_licence_class: '',
    remuneration_group: '',
    learned_profession: '',
    activity_at_work: '',
    qualification: '',
    employment_type: '',
    user_apps: '',
  },
  transformMita: (mita) => {
    let trueValues = ['1', 'J', 'j', 'true', 'X', 'x', 'ja', 'Ja', 'JA'];
    mita.id = v4();
    if (mita.price_int === undefined) {
      mita.price_int = 0;
    }
    mita.price_int = ("" + mita.price_int).replace('.', ',').replace('€', '').replace('EU', '').trim();
    if (mita.price_ext === undefined) {
      mita.price_ext = 0;
    }
    mita.price_ext = ("" + mita.price_ext).replace('.', ',').replace('€', '').replace('EU', '').trim();
    if (mita.pers_number === undefined) {
      mita.pers_number = '';
    }
    mita.pers_number = ("" + mita.pers_number);
    mita.blocked = trueValues.includes(mita.blocked);
    mita.ginkom01 = trueValues.includes(mita.ginkom01);
    if (mita.azra === undefined) {
      mita.azra = '';
    }
    mita.azra = mita.azra.replace('AZRA@', '');
    return mita;
  },
  data () {
    return {
      cols: [
        {type: 'readonly', title: 'Laufende Nummer', name: 'bis_id', width: '130', readOnly: true},
        {type: 'text', title: 'Name, Vorname', name: 'name', width: '200', required: true, max_length: '50'},
        {type: 'text', title: 'Personal-Nummer', name: 'pers_number', width: '160', required: true,},
        {type: 'dropdown', title: 'Kostenstelle', name: 'kost', width: '200', required: true, max_length: '50', source: []},
        {type: 'dropdown', title: 'Mitarbeitergruppe', name: 'migr', width: '200', required: true, max_length: '50', source: [], filter: this.migrFilter},
        {type: 'dropdown', title: 'Arbeitszeitraster', name: 'azra', width: '200', max_length: '50', source: []},
        {type: 'calendar', title: 'Eintrittsdatum', name: 'start_date', options: { format:'DD.MM.YYYY' }, width: '130'},
        {type: 'calendar', title: 'Austrittsdatum', name: 'end_date', options: { format:'DD.MM.YYYY' }, width: '130'},
        {type: 'checkbox', title: 'Gesperrt', name: 'blocked', width: '80', align: 'center'},
        {type: 'numeric', title: 'VP-intern', name: 'price_int', mask:'#.##,00 €', decimal:',', width: '90', required: true,},
        {type: 'numeric', title: 'VP-extern', name: 'price_ext', mask:'#.##,00 €', decimal:',', width: '90', required: true,},
        {type: 'checkbox', title: 'Verwaltung', name: 'ginkom01', width: '100', align: 'center'},
        {type: 'numeric', title: 'Wegzeit', name: 'way_time', mask:'#.## min', width: '100'},
        {type: 'text', title: 'Führerscheinklassen', name: 'drivers_licence_class', width: '160'},
        {type: 'text', title: 'Vergütungsgruppe', name: 'remuneration_group', width: '160'},
        {type: 'text', title: 'Erlernter Beruf', name: 'learned_profession', width: '160'},
        {type: 'text', title: 'Tätigkeit im Bauhof', name: 'activity_at_work', width: '160'},
        {type: 'text', title: 'Qualifikation', name: 'qualification', width: '160'},
        {type: 'text', title: 'Beschäftigungsverhältnis', name: 'employment_type', width: '200'},
        {type: 'hidden', title: '', name: 'object_group', width: '0'},
        {type: 'hidden', title: '', name: 'kloon_id', width: '0'},

      ],
      mitas: [],
      kostMap: {},
      kosts: [],
      azras: [],
      loader: undefined,
      singleEdit: true,
      hasSelects: false,
      currentSelection: [],
      isEdit: false,
      editId: '',

      isDetail: false,
      itemId: null,
      currentItem: null,
      currentItemIndex: null,
      errorMessage: '',
      showErrorMessage: false,

      possibleApps: [],
      possibleAppsSelected: [],
      kloonKey: '',
      kloonApiKey: '',
      appMap: [
        {name: 'Tagesbericht', value: 'tb'},
        {name: 'Baumkontrolle', value: 'bk'},
        {name: 'Team:o', value: 'to'},
        {name: 'Alarmserver', value: 'as'},
        {name: 'Winterdienst', value: '1'},
        {name: 'Straßenreinigung', value: '2'},
        {name: 'Straßenkontrolle', value: '3'},
        {name: 'Spielplatzkontrolle', value: '6'},
        // {name: 'GPS-Kontrolle', value: '9'},  war für Freising
        {name: 'Straßenkontrolle (v1)', value: '10'},
        {name: 'Mähnachweis', value: '11'},
        {name: 'Sturmkontrolle Bäume', value: '12'},
        {name: 'Rufer Winterdienst', value: '13'},
      ],
      isAdmin: false,
      showAppSettingsDialog: false,
      modeSetup: false,
    }
  },
  mounted () {
  },
  created() {
    this.isAdmin = this.$cookies.get("ps_username") === 'admin';
    this.singleEdit = !this.isAdmin;
    //this.cols[2].readOnly = !this.isAdmin;
    this.cols[8].readOnly = !this.isAdmin;

    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/basis_data/mita'
    ).then(this.responseOkGet, this.responseError)
  },
  computed: {
    employmentTypes() {
      let s = new Set();
      for (let i = 0; i < this.mitas.length; i++) {
        if (this.mitas[i].employment_type !== '') {
          s.add(this.mitas[i].employment_type)
        }
      }
      return [...s];
    },
    qualifications() {
      let s = new Set();
      for (let i = 0; i < this.mitas.length; i++) {
        if (this.mitas[i].qualification !== '') {
          s.add(this.mitas[i].qualification)
        }
      }
      return [...s];
    },
    appSelects() {
      let res = [];
      for (let i = 0; i < this.possibleApps.length; i++) {
        if (this.appMap.find(app => app.value === this.possibleApps[i])) {
          res.push(this.appMap.find(app => app.value === this.possibleApps[i]))
        }
      }
      return res;
    }
  },
  methods: {
    onImport(daten) {
      if (daten.length === 0) {
        return;
      }
      this.isEdit = true;
      // fill apps
      let trueValues = ['1', 'J', 'j', 'true', 'X', 'x', 'ja', 'Ja', 'JA'];
      for (let i = 0; i < daten.length; i++) {
        for (let j = 0; j < this.possibleApps.length; j++) {
          daten[i]['app_' + this.possibleApps[j]] = trueValues.includes(daten[i]['app_' + this.possibleApps[j]]);
        }
      }
      this.mitas = daten;
      this.$nextTick(() => {
        this.$refs.spreadsheet.reload();
      });
    },
    onDelete() {
      if (this.modeSetup) {
        this.$refs.spreadsheet.deleteRows(this.currentSelection[0], this.currentSelection.length);
        this.currentSelection = [];
        this.hasSelects = false;
      }
    },
    toggleSetupMode() {
      this.modeSetup = !this.modeSetup;
      //this.cols[2].readOnly = !this.modeSetup;
      this.cols[8].readOnly = !this.modeSetup;
      this.cols[3].type = this.modeSetup ? 'text' : 'dropdown';
      this.cols[4].type = this.modeSetup ? 'text' : 'dropdown';
      this.cols[5].type = this.modeSetup ? 'text' : 'dropdown';
      this.$nextTick(() => {
        this.$refs.spreadsheet.mountSpreadsheet();
      });
    },
    onSave() {
      let data = [];
      if (this.isDetail) {
        data = [this.$refs.detail.getData()];
      } else if (this.singleEdit) {
        data = this.$refs.spreadsheet.getData(this.editId);
        if (data.start_date !== "") {
          data.start_date = data.start_date.split(" ")[0].split("-").reverse().join(".");
        }
        if (data.end_date !== "") {
          data.end_date = data.end_date.split(" ")[0].split("-").reverse().join(".");
        }
        if (data.price_int === 0) {
          this.errorMessage = "Der interne Verrechnungspreis muss gesetzt sein.";
          this.showErrorMessage = true;
          return;
        }
        if (data.price_ext === 0) {
          this.errorMessage = "Der externe Verrechnungspreis muss gesetzt sein.";
          this.showErrorMessage = true;
          return;
        }
        data.price_int = data.price_int.replace('€', '').replace('EU', '').trim();
        data.price_ext = data.price_ext.replace('€', '').replace('EU', '').trim();
        data.user_apps = [];
        for (let i = 0; i < this.possibleApps.length; i++) {
          if (this.appMap.find(app => app.value === this.possibleApps[i])) {
            if (data['app_' + this.possibleApps[i]]) {
              data.user_apps.push(this.possibleApps[i]);
            }
          }
        }
        data.user_apps = data.user_apps.join('|');
        data = [data]
      } else {
        // multi edit
        data = this.$refs.spreadsheet.getAllData();
        for (let i = 0; i < data.length; i++) {
          if (data[i].start_date !== "") {
            data[i].start_date = data[i].start_date.split(" ")[0].split("-").reverse().join(".");
          }
          if (data[i].end_date !== "") {
            data[i].end_date = data[i].end_date.split(" ")[0].split("-").reverse().join(".");
          }
          if (data[i].price_int === 0) {
            this.errorMessage = "Der interne Verrechnungspreis muss gesetzt sein.";
            this.showErrorMessage = true;
            return;
          }
          if (data[i].price_ext === 0) {
            this.errorMessage = "Der externe Verrechnungspreis muss gesetzt sein.";
            this.showErrorMessage = true;
            return;
          }
          data[i].price_int = data[i].price_int.replace('€', '').replace('EU', '').trim();
          data[i].price_ext = data[i].price_ext.replace('€', '').replace('EU', '').trim();
          data[i].user_apps = [];
          for (let j = 0; j < this.possibleApps.length; j++) {
            if (this.appMap.find(app => app.value === this.possibleApps[j])) {
              if (data[i]['app_' + this.possibleApps[j]]) {
                data[i].user_apps.push(this.possibleApps[j]);
              }
            }
          }
          data[i].user_apps = data[i].user_apps.join('|');
        }
      }
      // fix the data
      for (let i = 0; i < data.length; i++) {
        // fix the price format
        data[i].price_int = parseFloat(data[i].price_int.replace(/\./g,'').replace(',', '.'));
        if (isNaN(data[i].price_int)) {
          data[i].price_int = 0;
        }
        if (data[i].price_int === 0) {
          this.errorMessage = "Der interne Verrechnungspreis muss gesetzt sein.";
          this.showErrorMessage = true;
          return;
        }
        data[i].price_int = data[i].price_int.toString().replace(/[.]/, ",") + 'EU';

        data[i].price_ext = parseFloat(data[i].price_ext.replace(/\./g,'').replace(',', '.'));
        if (isNaN(data[i].price_ext)) {
          data[i].price_ext = 0;
        }
        if (data[i].price_ext === 0) {
          this.errorMessage = "Der externe Verrechnungspreis muss gesetzt sein.";
          this.showErrorMessage = true;
          return;
        }
        data[i].price_ext = data[i].price_ext.toString().replace(/[.]/, ",") + 'EU';
        data[i].name = data[i].name.trim();
        if (data[i].end_date !== '') {
          data[i].end_date = data[i].end_date.split('.').reverse().join('');
        } else {
          data[i].end_date = '99999999';
        }
        data[i].blocked =  data[i].blocked ? '1' : '0';
        data[i].ginkom01 =  data[i].ginkom01 ? '1' : '0';
        data[i].kloon_id =  data[i].kloon_id === '' ? 0 : data[i].kloon_id;
      }
      this.errorMessage = this.validate(data);
      if (this.errorMessage) {
        this.showErrorMessage = true;
        return;
      }
      this.showLoader();
      encryptData(sessionStorage.getItem("aes"), data, ['name']).then(encrypted => {
        this.$http.post(
            Server_URL_ZK + '/zk/basis_data/mita', {'mitas': encrypted, 'key': sessionStorage.getItem("aes"), is_setup: this.modeSetup}
        ).then(this.responseOkPost, this.responseError)
      });
    },
    validate(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].name.trim() === "") {
          return "Der Name muss gesetzt sein."
        }
        if (data[i].pers_number.trim() === "") {
          return "Die Personalnummer muss gesetzt sein."
        }
        if (data[i].kost.trim() === "") {
          return "Die Kostenstelle muss gesetzt sein."
        }
        if (data[i].migr.trim() === "") {
          return "Die Mitarbeitergruppe muss gesetzt sein."
        }

        // check if migr is a child of kost
        if (!this.modeSetup) {
          if (this.kostMap[data[i].kost] !== undefined) {
            if (!this.kostMap[data[i].kost].includes(data[i].migr)) {
              return "Die Mitarbeitergruppe muss zur Kostenstelle passen."
            }
          } else {
            return "Die Kostenstelle ist nicht gültig."
          }
        }
      }
      return "";
    },
    moveSelection(direction, gotToMax) {
      if (this.isDetail) {
        if (gotToMax) {
          this.currentItemIndex = direction === 'left' ? 0 : this.mitas.length - 1;
        } else {
          this.currentItemIndex = direction === 'left' ? this.currentItemIndex - 1 : this.currentItemIndex + 1;
        }
        this.currentItem = this.mitas[this.currentItemIndex];
      }
    },
    toggleDetails() {
      if (!this.isDetail) {
        this.currentItem = this.itemId ? this.mitas.find(item => item.id === this.itemId) : this.mitas[0];
        this.currentItemIndex = this.mitas.findIndex(item => item.id === this.currentItem.id);
      } else {
        this.hasSelects = false;
        this.currentSelection = [];
        this.itemId = '';
      }

      this.isDetail = !this.isDetail;
      if (this.isDetail) {
        //this.$refs.detail.$emit('change', false);
      } else {
        this.$nextTick(() => {
          this.$refs.spreadsheet.mountSpreadsheet();
        });
      }
    },
    saveAppSettings() {
      let setting = this.possibleAppsSelected.join('|');
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/basis_data/mita_app_settings', {value: setting, kloon_key: this.kloonKey, kloon_api_key: this.kloonApiKey}
      ).then(this.responseOkReload, this.responseError)
    },
    migrFilter(instance, cell, c, r, source) {
      let value = instance.jexcel.getValueFromCoords(c - 1, r);
      if (value === '') {
        return source;
      } else if (this.kostMap[value] !== undefined) {
        return this.kostMap[value];
      } else {
        return [];
      }
    },
    selectionChange(hasSelection, selection) {
      this.hasSelects = hasSelection;
      this.currentSelection = selection;
      if ((!this.singleEdit || !this.isEdit)) {
        if (hasSelection) {
          this.itemId = this.mitas[selection[0]].id;
        } else {
          this.itemId = '';
        }
      }
    },
    dblClick(index) {
      if (!this.isEdit) {
        this.itemId = this.mitas[index].id;
        this.toggleDetails();
      }
    },
    resetEdit() {
      let deleteIndex = -1;
      for (let i = 0; i < this.mitas.length; i++) {
        if (this.mitas[i].id === this.editId && this.mitas[i].bis_id === 'Neuanlage') {
          deleteIndex = i;
          break
        }
      }
      if (deleteIndex !== -1) {
        this.mitas.splice(deleteIndex, 1);
      }
      if (!this.isDetail) {
        if (!this.singleEdit) {
          this.$nextTick(() => {
            this.$refs.spreadsheet.reload();
          });
        } else {
          let editId = this.editId;
          this.$nextTick(() => {
            this.$refs.spreadsheet.resetEdit(editId);
          });        }
      } else {
        if (this.currentItem.bis_id !== 'Neuanlage') {
          this.$refs.detail.resetEdit();
        } else {
          this.moveSelection('left', true)
        }
      }
      this.editId = '';
      this.isEdit = false;
    },
    addRow() {
      if (!this.isDetail) {
        this.toggleDetails();
      }
      let d ={
        id: v4(),
        bis_id: 'Neuanlage',
        kloon_id: 0,
        name: '',
        pers_number: '',
        kost: '',
        migr: '',
        azra: '',
        start_date: '',
        end_date: '',
        blocked: false,
        price_int: '',
        price_ext: '',
        ginkom01: false,
        way_time: '0',
        drivers_licence_class: '',
        remuneration_group: '',
        learned_profession: '',
        activity_at_work: '',
        qualification: '',
        employment_type: '',
        user_apps: '',
      };
      this.mitas.push(d);
      if(this.isDetail) {
        this.currentItem = d;
        this.currentItemIndex = this.mitas.length - 1;
        this.editId = d.id;
        this.isEdit = true;
      } else {
        this.$refs.spreadsheet.addRow(d);
      }
    },
    dataChanged(id) {
      this.editId = id;
      if (!this.isDetail) {
        this.itemId = '';
      }
      this.isEdit = true;
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkReload(response) {
      this.hideLoader();
      if (response.status === 200) {
        window.location.reload();
      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.possibleApps = response.body.app_settings === '' ? [] : response.body.app_settings.split('|');
        this.kloonKey = response.body.kloon_key;
        this.kloonApiKey = response.body.kloon_api_key;
        // add cols for all possible apps
        for (let i = 0; i < this.possibleApps.length; i++) {
          if (this.appMap.find(app => app.value === this.possibleApps[i])) {
            this.cols.push({
              type: 'checkbox',
              title: this.appMap.find(app => app.value === this.possibleApps[i]).name,
              name: 'app_' + this.possibleApps[i],
              width: '100',
              align: 'center'
            });
          }
        }
        this.mitas = await this.processMitas(response.body.mitas);
        this.kostMap = response.body.kost_map;
        this.kosts = response.body.kosts;
        this.azras = response.body.azras;
        this.cols[3].source = response.body.kosts;
        this.cols[4].source = response.body.migrs;
        this.cols[5].source = response.body.azras;
        this.$nextTick(() => {
          this.$refs.spreadsheet.mountSpreadsheet();
        });
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkPost(response) {
      this.hideLoader();
      if (response.status === 200) {
        let items = (await this.processMitas(response.body));
        if (this.singleEdit || this.isDetail) {
          let item = items[0];
          for (let i = 0; i < this.mitas.length; i++) {
            if (this.mitas[i].id === item.id) {
              this.mitas[i] = item;
              break;
            }
          }
          if (this.isDetail) {
            this.currentItem = item;
          } else {
            this.$refs.spreadsheet.updateRow(item);
          }
          this.editId = '';
          this.isEdit = false;
        } else if (this.modeSetup) {
          window.location.reload();
        } else  {
          this.mitas = items;
          this.$nextTick(() => {
            this.$refs.spreadsheet.reload();
          });
          this.editId = '';
          this.isEdit = false;
        }
      } else {
        window.location = Redirect_500;
      }
    },
    async processMitas(mitas) {
      mitas = await decryptData(sessionStorage.getItem("aes"), mitas, ['name']);
      for (let i = 0; i < mitas.length; i++) {
        // format end_date
        if (mitas[i].end_date === '99999999') {
          mitas[i].end_date = '';
        } else {
          // has weird formate 20240630 bring it to 30.06.2024
          mitas[i].end_date = LuxonDateTime.fromFormat(mitas[i].end_date, 'yyyyMMdd').toFormat('dd.MM.yyyy');
        }
        // format blocked
        mitas[i].blocked = mitas[i].blocked === '1' || mitas[i].blocked === 'J' || mitas[i].blocked === 'j' || mitas.blocked === 'true';
        mitas[i].ginkom01 = mitas[i].ginkom01 === '1' || mitas[i].ginkom01 === 'J' || mitas[i].ginkom01 === 'j' || mitas.ginkom01 === 'true';

        // format azra
        mitas[i].azra = mitas[i].azra.replace('AZRA@', '');

        if (mitas[i].user_apps !== '') {
          let apps = mitas[i].user_apps.split('|');
          for (let j = 0; j < this.possibleApps.length; j++) {
            mitas[i]['app_' + this.possibleApps[j]] = apps.includes(this.possibleApps[j]);
          }
        }
      }
      // order by name
      mitas.sort((a, b) => {
        return a.bis_id.localeCompare(b.bis_id);
      });
      return mitas;
    }
  }

}
</script>

<style scoped>

.t-btn {
  height: 32px !important;
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
  margin: auto 12px auto 0px;
}

.t-btn-long {
  height: 32px !important;
  width: 240px !important;
  max-width: 240px !important;
  min-width: 240px !important;
  margin: auto 12px auto 0px;
}

.t-btn-left {
  margin: auto 12px auto auto !important;
}


::v-deep label {
  margin-bottom: initial;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

::v-deep .jexcel_content {
  height: calc(100vh - 55px - 2.55rem - 24px);
}

::v-deep .jexcel_container {
  height: calc(100vh - 55px - 2.55rem - 15px);
}

</style>

